'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/axios/lib/cancel/isCancel.js